module.exports = __webpack_public_path__ + "static/img_5164-460e5dd033043cf34ea98b493fe2f164.webp";